export const relationshipKeys = {
  role: 'name',
  regional: 'name',
  vehicle: 'licensePlate',
  partner: 'name',
  company: 'name',
  project: 'name',
  driver: 'name',
  vehicleType: 'name',
  checklist: 'name',
  checklists: 'name',
  drivers: 'name',
};
